// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.living-labs-page {
    padding-top: 80px;
    min-height: 100vh;
    background-color: #f8f9fa;
}

.ll-hero {
    background: linear-gradient(135deg, #1a2a3a 0%, #2c3e50 100%);
    color: #fff;
    padding: 60px 20px;
    text-align: center;
}

.ll-hero-cities {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 20px;
}

.ll-hero-cities span {
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: 3px;
    color: #3498db;
}

.ll-hero-title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 16px;
}

.ll-hero-subtitle {
    font-size: 1.2rem;
    font-weight: 400;
    color: #bdc3c7;
    margin-bottom: 24px;
}

.ll-hero-desc {
    max-width: 800px;
    margin: 0 auto;
    font-size: 1rem;
    line-height: 1.7;
    color: #ddd;
}

.ll-section {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;
}

.ll-section-subtitle {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 16px;
    font-weight: 600;
}

.ll-section-text {
    font-size: 1rem;
    color: #555;
    line-height: 1.7;
}

.ll-lab {
    max-width: 1100px;
    margin: 0 auto;
    padding: 40px 20px 50px;
    border-top: 1px solid #e0e0e0;
}

.ll-lab-label {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #888;
    margin-bottom: 8px;
    font-weight: 600;
}

.ll-lab-title {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 24px;
    font-weight: 700;
}

.ll-lab-content {
    display: flex;
    gap: 32px;
    align-items: flex-start;
}

.ll-lab-image-wrap {
    flex: 0 0 45%;
}

.ll-lab-image {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.ll-lab-text {
    flex: 1 1;
}

.ll-lab-text p {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.7;
    margin-bottom: 14px;
}

.ll-link {
    color: #3498db;
    font-weight: 600;
    text-decoration: none;
    font-size: 0.95rem;
    display: inline-block;
    margin-top: 8px;
    transition: color 0.2s ease;
}

.ll-link:hover {
    color: #2980b9;
    text-decoration: underline;
}

.ll-scenarios {
    margin-top: 40px;
}

.ll-scenarios-title {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 20px;
    font-weight: 600;
}

.ll-scenarios-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
}

.ll-scenario-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: block;
}

a.ll-scenario-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.ll-scenario-card h4 {
    font-size: 0.95rem;
    color: #2c3e50;
    font-weight: 600;
    margin: 0;
}

a.ll-scenario-card h4 {
    color: #3498db;
}

@media (max-width: 768px) {
    .ll-hero {
        padding: 40px 16px;
    }

    .ll-hero-cities {
        gap: 20px;
    }

    .ll-hero-cities span {
        font-size: 0.9rem;
    }

    .ll-hero-title {
        font-size: 1.8rem;
    }

    .ll-lab-content {
        flex-direction: column;
    }

    .ll-lab-image-wrap {
        flex: none;
        width: 100%;
    }

    .ll-scenarios-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LivingLabsPage/LivingLabsPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,qBAAqB;IACrB,cAAc;IACd,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".living-labs-page {\n    padding-top: 80px;\n    min-height: 100vh;\n    background-color: #f8f9fa;\n}\n\n.ll-hero {\n    background: linear-gradient(135deg, #1a2a3a 0%, #2c3e50 100%);\n    color: #fff;\n    padding: 60px 20px;\n    text-align: center;\n}\n\n.ll-hero-cities {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin-bottom: 20px;\n}\n\n.ll-hero-cities span {\n    font-size: 1.1rem;\n    font-weight: 600;\n    letter-spacing: 3px;\n    color: #3498db;\n}\n\n.ll-hero-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 16px;\n}\n\n.ll-hero-subtitle {\n    font-size: 1.2rem;\n    font-weight: 400;\n    color: #bdc3c7;\n    margin-bottom: 24px;\n}\n\n.ll-hero-desc {\n    max-width: 800px;\n    margin: 0 auto;\n    font-size: 1rem;\n    line-height: 1.7;\n    color: #ddd;\n}\n\n.ll-section {\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 40px 20px;\n}\n\n.ll-section-subtitle {\n    font-size: 1.3rem;\n    color: #2c3e50;\n    margin-bottom: 16px;\n    font-weight: 600;\n}\n\n.ll-section-text {\n    font-size: 1rem;\n    color: #555;\n    line-height: 1.7;\n}\n\n.ll-lab {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 40px 20px 50px;\n    border-top: 1px solid #e0e0e0;\n}\n\n.ll-lab-label {\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    color: #888;\n    margin-bottom: 8px;\n    font-weight: 600;\n}\n\n.ll-lab-title {\n    font-size: 2rem;\n    color: #2c3e50;\n    margin-bottom: 24px;\n    font-weight: 700;\n}\n\n.ll-lab-content {\n    display: flex;\n    gap: 32px;\n    align-items: flex-start;\n}\n\n.ll-lab-image-wrap {\n    flex: 0 0 45%;\n}\n\n.ll-lab-image {\n    width: 100%;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.ll-lab-text {\n    flex: 1;\n}\n\n.ll-lab-text p {\n    font-size: 0.95rem;\n    color: #555;\n    line-height: 1.7;\n    margin-bottom: 14px;\n}\n\n.ll-link {\n    color: #3498db;\n    font-weight: 600;\n    text-decoration: none;\n    font-size: 0.95rem;\n    display: inline-block;\n    margin-top: 8px;\n    transition: color 0.2s ease;\n}\n\n.ll-link:hover {\n    color: #2980b9;\n    text-decoration: underline;\n}\n\n.ll-scenarios {\n    margin-top: 40px;\n}\n\n.ll-scenarios-title {\n    font-size: 1.3rem;\n    color: #2c3e50;\n    margin-bottom: 20px;\n    font-weight: 600;\n}\n\n.ll-scenarios-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 16px;\n}\n\n.ll-scenario-card {\n    background: #fff;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n    text-decoration: none;\n    color: inherit;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    display: block;\n}\n\na.ll-scenario-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.ll-scenario-card h4 {\n    font-size: 0.95rem;\n    color: #2c3e50;\n    font-weight: 600;\n    margin: 0;\n}\n\na.ll-scenario-card h4 {\n    color: #3498db;\n}\n\n@media (max-width: 768px) {\n    .ll-hero {\n        padding: 40px 16px;\n    }\n\n    .ll-hero-cities {\n        gap: 20px;\n    }\n\n    .ll-hero-cities span {\n        font-size: 0.9rem;\n    }\n\n    .ll-hero-title {\n        font-size: 1.8rem;\n    }\n\n    .ll-lab-content {\n        flex-direction: column;\n    }\n\n    .ll-lab-image-wrap {\n        flex: none;\n        width: 100%;\n    }\n\n    .ll-scenarios-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
